(function (s, t, o, n, l, y, _) {
  if (s.stonlyTrack) return;
  _ = s.stonlyTrack = function () {
    _._api ? _._api.apply(_, arguments) : _.queue.push(arguments);
  };
  _.queue = [];
  y = t.createElement(o);
  y.async = !0;
  y.src = n;
  l = t.getElementsByTagName(o)[0];
  l.parentNode.insertBefore(y, l);
})(window, document, 'script', 'https://stonly.com/js/tracker/stn.js');
stonlyTrack('init', '20837fd9-cec9-11eb-8dbf-062882f67cfe');
